// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { Attributor, Scope } = Quill.import('parchment');

export default new Attributor('strokeThickness', 'data-stroke-thickness', { scope: Scope.INLINE });
export const BlockStrokeThicknessAttributor = new Attributor(
    'blockStrokeThickness',
    'data-stroke-thickness',
    { scope: Scope.BLOCK },
);
